import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

function relicNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "relic", next, x, y });
}

// 第12期。共有2件のあと3道に分かれ、中盤から中央へ一方通行に寄せる（＝集中）。
// 中央道を加えて選択肢を保ちつつ、休日から1段飛ばしの長い辺を1本だけ置く。
// 入次数は2まで、交差なし。
export const MAP_NODES_FOCUS: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["t1"], x: 3, y: 0 }),
  t1: caseNode("t1", ["t2"], 3, 1),
  t2: caseNode("t2", ["t3l", "t3m", "t3r"], 3, 2),
  t3l: caseNode("t3l", ["t4a", "rest4b"], 1, 3),
  t3m: caseNode("t3m", ["t4b"], 3, 3),
  t3r: caseNode("t3r", ["t4d", "e4e"], 5, 3),
  t4a: caseNode("t4a", ["t5a"], 0, 4),
  "rest4b": restNode("rest4b", ["t6b"], 2, 4),
  t4b: caseNode("t4b", ["t5b"], 3, 4),
  t4d: caseNode("t4d", ["t5d"], 4, 4),
  e4e: eventNode("e4e", ["relic5e"], 6, 4),
  t5a: caseNode("t5a", ["t6a"], 1, 5),
  t5b: caseNode("t5b", ["t6b", "t6c"], 3, 5),
  t5d: caseNode("t5d", ["t6c", "t6e"], 5, 5),
  "relic5e": relicNode("relic5e", ["t6e"], 6, 5),
  t6a: caseNode("t6a", ["t7a"], 0, 6),
  t6b: caseNode("t6b", ["t7a", "t7b"], 2, 6),
  t6c: caseNode("t6c", ["t7b", "rest7d"], 3, 6),
  t6e: caseNode("t6e", ["rest7d"], 6, 6),
  t7a: caseNode("t7a", ["t8a", "t8b"], 1, 7),
  t7b: caseNode("t7b", ["t8b", "t8c"], 3, 7),
  "rest7d": restNode("rest7d", ["t8c", "relic8e"], 5, 7),
  t8a: caseNode("t8a", ["rest9l"], 0, 8),
  t8b: caseNode("t8b", ["rest9l"], 2, 8),
  t8c: caseNode("t8c", ["rest9r"], 4, 8),
  "relic8e": relicNode("relic8e", ["rest9r"], 6, 8),
  "rest9l": restNode("rest9l", ["boss"], 2, 9),
  "rest9r": restNode("rest9r", ["boss"], 4, 9),
  boss: node("boss", { kind: "case", caseId: "focus-boss", next: [], x: 3, y: 10 }),
};
